/**
 * step
 */
export enum CustomizeStep {
  ChooseProductSpec = 1,
  ChooseSpec = 2,
  ChooseAddon = 3,
  ChooseImprint = 4,
  ChooseDropShip = 5,
  ChooseProducttiomTime = 6,
}

/**
 * 订单类型美剧
 */

export enum OrderType {
  Normal = 0,
  SpecSample = 1,
}
